import { render, staticRenderFns } from "./TrivestDialog.vue?vue&type=template&id=1f9b084a&scoped=true"
import script from "./TrivestDialog.vue?vue&type=script&lang=ts"
export * from "./TrivestDialog.vue?vue&type=script&lang=ts"
import style0 from "./TrivestDialog.vue?vue&type=style&index=0&id=1f9b084a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9b084a",
  null
  
)

export default component.exports